<div class="relative w-full">
  <div class="relative w-full h-[360px]" [class.opacity-0]="!chartFinished()" [class.opacity-100]="chartFinished()">
    <div
      echarts
      class="w-full h-full pr-6 transition-opacity duration-300"
      [options]="chartOption()"
      (chartClick)="onChartClick($event)"
      (chartInit)="onChartInit($event)"
      (chartFinished)="onChartFinished()"
    ></div>

    <button
      mat-icon-button
      class="!absolute bottom-[6px] -right-3 2xl:right-0 z-10 mat-secondary-gray-border-button-color"
      (click)="selectNextPoint()"
    >
      <app-icon src="/icons/arrow-right.svg" alt="Next" [size]="12" />
    </button>
  </div>

  @if (!chartFinished()) {
    <div class="absolute inset-0 h-[360px]">
      <div class="w-full h-full flex items-center justify-center flex-col gap-10">
        <div class="w-full h-[288px] pt-10 pl-20 pr-12">
          <ngx-skeleton-loader
            class="w-full h-full"
            [theme]="{ width: '100%', height: '100%', 'border-radius': '4px' }"
          />
        </div>

        <div class="flex items-center gap-3 w-full h-7 pl-20">
          <ngx-skeleton-loader
            class="h-7 -mt-1 w-full pr-3"
            [theme]="{ width: '100%', height: '28px', 'border-radius': '4px' }"
          />
          <ngx-skeleton-loader
            class="h-6 w-6 -mt-1"
            [theme]="{ width: '24px', height: '24px', 'border-radius': '100vw' }"
          />
        </div>
      </div>
    </div>
  }
</div>
